import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export function carousel() {
  const carousel = document.querySelectorAll('.js-carousel');
  if(carousel.length) {
    for (let i = 0; i < carousel.length; i++) {
      const el = carousel[i];
      new Swiper(el, {
        modules: [Navigation, Pagination],
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        slidesPerView: 'auto',
        spaceBetween: 0,
        edgeSwipeThreshold: 100,
        grabCursor: true
      });
    }
  }
}